import React, { useEffect, useRef, useState } from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, Space, Tooltip } from "antd";
import "./foreman_data.css";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { ImCancelCircle } from "react-icons/im";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import ForemanDataTable from "../../components/hoc_foreman_data";
import { FaArrowRight } from "react-icons/fa6";
import { GiCheckMark } from "react-icons/gi";


const ForemanData: React.FC = () => {
    const [form] = Form.useForm();
    const tableRef = useRef<any>(null);
    const [autosaveStatus, setAutosaveStatus] = useState<string>('stopped');
    const status = Form.useWatch("status", form);

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const Deactivebtn = ImCancelCircle as React.ComponentType<any>;
    const Activedbtn = GiCheckMark as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Addrow = FaArrowRight as React.ComponentType<any>;

    return (

        <div id="id2o" style={transformStyle}>
            <div className="gjs-grid-row" id="ibsf">
                <div className="gjs-grid-column" id="ivkyi">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_data_foreman",
                                title: (
                                    <>
                                        <span>Data Foreman</span>
                                    </>
                                ),
                            },
                            {
                                title: "Foreman",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="ifvij">
                <div className="gjs-grid-column" id="i3sgf">
                    <Button className="gr-button" onClick={() => tableRef.current?.handleGenerateNew()}>
                        <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button" onClick={() => tableRef.current?.handleNew()}>
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Clear Form
                    </Button>
                    {status === "Deactive" ? (
                        <Button
                            className="gr-button"
                            onClick={() => tableRef.current?.handleActive()}
                            style={{
                                backgroundColor: "#f6ffed",
                                borderColor: "#b7eb8f",
                                color: "#52c41a",
                            }}
                        >
                            <Activedbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                            Active
                        </Button>
                    ) : (
                        <Button className="gr-button" onClick={() => tableRef.current?.handleDeactive()}>
                            <Deactivebtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                            Deactive
                        </Button>
                    )}
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="i45mg">
                <div className="gjs-grid-column" id="iyerg">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 450 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Code"
                            name="code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly /> 
                        </Form.Item>
                        <Form.Item
                            label="Name"
                            name="name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                    </Form>

                </div>
            </div>
            <div className="gjs-grid-row" id="itvge">
                <div className="gjs-grid-column" id="ibjp8">
                    <Button
                        className="gr-button"
                        onClick={() => tableRef.current?.handleAdd()}
                        style={{ backgroundColor: '#1677ff', color: 'white' }}
                    >
                        <Addrow style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Add Arrow
                    </Button>
                    <ForemanDataTable
                        form={form}
                        ref={tableRef}
                        autosaveStatus={autosaveStatus}
                        setAutosaveStatus={setAutosaveStatus}
                    />
                </div>
            </div>
        </div>
    );
};

export default ForemanData;
